module.exports = __webpack_public_path__ + "static/media/interior-lining.fe608038.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/interior-lining.png
// module id = 1222
// module chunks = 0